module.exports = __webpack_public_path__ + "static/img/bg_mod_dianxin.d27dbc37.jpg";